import Toastify from "toastify-js"

import "toastify-js/src/toastify.css"

export function errorToast(error: Error) {
  const messageElement = document.createElement("div")
  messageElement.innerHTML = error.message

  Toastify({
    node: messageElement,
    duration: 15000, // 15 secs
    close: true,
    gravity: "top",
    position: "center",
    stopOnFocus: true, // Prevents dismissing of toast on hover
    className: "toastify-error"
  }).showToast()
}

/**
 *
 * @param error
 * @returns Returns true if the error was handled, false otherwise
 */
export const handleErrors = async (error: Response): Promise<boolean> => {
  try {
    const json = await error.json()
    if (typeof json.errors === "object") {
      const message = Object.values(json.errors).flat().join("\n")
      errorToast(new Error(message))
      return true
    }

    return false
  } catch (parseError) {
    console.log("Error parsing error response", parseError)
    return false
  }
}

export class FormValidationError extends Error {
  field: "email" | "password"

  constructor(field: "email" | "password") {
    super()
    this.field = field
  }
}

export class AuthenticationError extends Error {
  constructor(message: string) {
    super(message)
  }
}
